import request from '@/utils/request'

export function getToeflHearingList(url) { //查询聊天记录
  return request({
    url: '/api/toeflHearingList'+url,
    method: 'get'
  })
}